module.exports = __webpack_public_path__ + "img/wireframe-ball.b4601111.png";